import { render, staticRenderFns } from "./ProductStatusFilter.vue?vue&type=template&id=6fb0e05b&"
import script from "./ProductStatusFilter.vue?vue&type=script&lang=js&"
export * from "./ProductStatusFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports